import { Component, OnInit, Input, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { MatDataGridComponent } from '../../../../comum/controls/mat-datagrid';
import { AngularFirestore } from 'angularfire2/firestore';
import { ProdutoReferencia,IProdutoReferencia }  from '../../../../models/produtoReferencias.model';
import { DataModel } from '../../../../models/data.model';


@Component({
    selector: 'produto-referencia',
    templateUrl: 'produto-referencia.component.html',
    styles: [``]
})
export class ProdutoReferenciaComponent implements OnInit {
    refClass : ProdutoReferencia;
    fproduto: any;
    fitems: IProdutoReferencia[] = [];
    item: IProdutoReferencia;
    editing: boolean = false;
    colunas = [
        { field: 'codigo', text: "Código" },
        { field: 'nome', text: "Descrição", width:120 },
        //{ field: 'estoque', text: "Estoque" }
    ];
    @ViewChild("grid") grid: ElementRef<MatDataGridComponent>;
    @Input()
    get value() {
        return this.fproduto;
    }
    set value(x) {
        if (x.codigo) {
           this.fproduto = x;
           this.refClass.idProduto = x.id;
           this.refClass.getRefers(x.id, d=>{
               this.items = d;
           })
        } 
    } 

    @Input()
    get items(){
      return this.fitems;
    }
    set items(x){
          this.fitems = (x?x:[]);
          this.rowsChanged.emit(this.fitems.length);

    }

    @Output()
    rowsChanged = new EventEmitter();


    constructor(private db:AngularFirestore) {

       this.refClass = new ProdutoReferencia(db);

     }

    ngOnInit(): void { }

    doEditItem( ds ){
        console.log(ds);
        if (ds.state=="dsInsert"){
           this.item = {}
        } else {
            this.item = ds.values;
        }

        this.editing = true;
    }

    salvarItem(it) {
        this.item.id = this.item.id;
        this.refClass.updateOrInsert(this.item.id, DataModel.validate( this.item));
        this.editing = false;
    }
    cancelarItem() {
        this.editing = false;
    }

   doDeleteItem(it){
       let idProd = this.item.id;
       this.refClass.delete(it.id);
       this.editing = false;
       
   }

}
